export function isGooglePhoto(url) {
    const regex = /^https:\/\/lh3\.googleusercontent\.com\/.*/;
    
    return regex.test(url);
}
